export const boatTranslations = {
  "Canoa de Madeira": {
    name: {
      en: "Wooden Canoe",
      es: "Canoa de Madera",
      zh: "木制独木舟"
    },
    description: {
      en: "Simple and effective for calm waters",
      es: "Simple y eficaz para aguas tranquilas",
      zh: "简单实用，适合平静水域"
    }
  },
  "Pequena Eva": {
    name: {
      en: "Little Eva",
      es: "Pequeña Eva",
      zh: "小伊娃"
    },
    description: {
      en: "Perfect for beach fishing",
      es: "Perfecto para pescar en la playa",
      zh: "完美的海滩钓鱼船"
    }
  },
  "Pescador Solitário": {
    name: {
      en: "Lone Fisherman",
      es: "Pescador Solitario",
      zh: "独钓者"
    },
    description: {
      en: "Ideal for lake fishing",
      es: "Ideal para pescar en lagos",
      zh: "理想的湖泊钓鱼船"
    }
  },
  "Mauá": {
    name: {
      en: "Mauá",
      es: "Mauá",
      zh: "玛瓦"
    },
    description: {
      en: "Tough enough to face the Amazon waters",
      es: "Resistente para enfrentar las aguas del Amazonas",
      zh: "足够坚固，能应对亚马逊河水"
    }
  },
  "Navio Marianas": {
    name: {
      en: "Marianas Ship",
      es: "Barco Marianas",
      zh: "马里亚纳号"
    },
    description: {
      en: "Large and robust for deep-sea fishing",
      es: "Grande y robusto para pesca en alta mar",
      zh: "大型坚固的深海渔船"
    }
  },
  "Vasco da Gama": {
    name: {
      en: "Vasco da Gama",
      es: "Vasco da Gama",
      zh: "达伽马号"
    },
    description: {
      en: "Large and equipped for fishing and exploring",
      es: "Grande y equipado para pescar y explorar",
      zh: "大型全能的探索渔船"
    }
  },
  "Puro luxo": {
    name: {
      en: "Pure Luxury",
      es: "Puro Lujo",
      zh: "纯奢华"
    },
    description: {
      en: "Luxurious and comfortable for elite fishing",
      es: "Lujoso y confortable para pesca de élite",
      zh: "豪华舒适的顶级渔船"
    }
  }
};
